import { Component } from '../../../libs/components/component';

class CurrentYear extends Component {
    onInit() {
        this.host.textContent = String(new Date().getFullYear());
    }
}
CurrentYear.declare('.js-current-year');